import TrackedVideoPlayer from '~/javascripts/components/TrackedVideoPlayer';
import cx from 'classnames';
import { observer } from 'mobx-react';

const CampaignBanner = observer(
  ({
    heroAttached,
    heroType,
    videoaskMediaId,
    videoUrl,
    videoAutoplay,
    campaignHeaderPhotoUrl,
  }) => {
    const showCampaignHeaderPhoto = () =>
      heroType == 'photo' && campaignHeaderPhotoUrl;

    return (
      <>
        <div
          className={cx(
            'mx-auto campaign-video-wrapper h-full flex flex-col items-center justify-center',
            {
              hidden: showCampaignHeaderPhoto(),
            }
          )}
        >
          {heroType == 'video' && (
            <div className='profile-video-container rounded-t'>
              {videoaskMediaId && (
                <video
                  autoPlay={videoAutoplay}
                  className='w-full p-0 border-none rounded rounded-b-none'
                  controls={true}
                  muted={videoAutoplay}
                >
                  <source
                    height='100%'
                    src={`https://media.videoask.com/transcoded/${videoaskMediaId}/video.mp4`}
                    style={{ borderWidth: '0px', overflow: 'hidden' }}
                    type='video/mp4'
                    width='100%'
                  />
                </video>
              )}
              {videoUrl && (
                <TrackedVideoPlayer
                  height='270'
                  muted={videoAutoplay}
                  playing={videoAutoplay}
                  url={videoUrl}
                  videoTrackingEventProperties={{
                    category: 'Video',
                    name: 'Custom Profile Campaign Video',
                  }}
                  width='480'
                />
              )}
              {!videoUrl && !videoaskMediaId && !heroAttached && (
                <TrackedVideoPlayer
                  height='270'
                  url='https://player.vimeo.com/video/180467014'
                  videoTrackingEventProperties={{
                    category: 'Video',
                    name: 'The Spring',
                    video_id: 180467014,
                  }}
                  width='480'
                />
              )}
            </div>
          )}
        </div>
        {showCampaignHeaderPhoto() && (
          <img
            className='block md-object-cover md-h-full md-w-full md-object-center rounded-t'
            src={campaignHeaderPhotoUrl}
          />
        )}
      </>
    );
  }
);

export default CampaignBanner;
